<ng-container *ngIf="formCtrl.invalid && formCtrl.touched">
  <ng-container *ngIf="formCtrl.errors as error">
    <ion-text *ngIf="error.isCustom" color="danger">
      {{ error.message }}
    </ion-text>
    <ion-text *ngIf="formCtrl.errors.required" color="danger">Required</ion-text>
    <ion-text *ngIf="formCtrl.errors.email" color="danger">Please type a valid email</ion-text>
    <ion-text *ngIf="formCtrl.errors.phone" color="danger">Please type a valid international phone number</ion-text>
    <ion-text *ngIf="formCtrl.errors.date" color="danger">Please type a valid date</ion-text>
    <!-- TODO: Handle the rest of the errors -->
  </ng-container>
</ng-container>
